import React, { useEffect } from 'react';
import useIsMobile from './useIsMobile';
import './App.css';

function Confidentialitate() {
    useEffect(() => { window.scrollTo(0, 0); document.title = 'Politica de Confidențialitate | SPCheapCars'; }, []);

    const primaryOrange = "#ff8e18";
    const trustNavy = "#1c2e4a";
    const isMobile = useIsMobile();

    const heroTexture = [
        'repeating-linear-gradient(125deg, transparent 0px, transparent 16px, rgba(255,255,255,0.06) 16px, rgba(255,255,255,0.06) 17px)',
        'repeating-linear-gradient(35deg, transparent 0px, transparent 32px, rgba(255,142,24,0.045) 32px, rgba(255,142,24,0.045) 33px)',
        'radial-gradient(ellipse at 70% 0%, rgba(255,142,24,0.1) 0%, transparent 50%)',
        'linear-gradient(180deg, rgba(28,46,74,0) 0%, rgba(15,26,43,0.5) 100%)'
    ].join(', ');

    const listStyle = { paddingLeft: '18px', margin: '8px 0 0' };

    const sections = [
        {
            icon: 'bi-database-fill', title: '1. Ce date colectăm?',
            body: <>
                Nu colectăm date personale sensibile prin simpla vizitare a site-ului. Putem colecta:
                <ul style={listStyle}>
                    <li><strong>Date tehnice:</strong> adresa IP, tipul browserului (prin log-uri de server standard, pentru securitate).</li>
                    <li><strong>Date de contact:</strong> dacă ne contactați telefonic sau prin email, vom folosi acele date doar pentru a vă răspunde.</li>
                </ul>
            </>
        },
        {
            icon: 'bi-bullseye', title: '2. Scopul Colectării',
            body: <>
                Datele sunt utilizate strict pentru:
                <ul style={listStyle}>
                    <li>Asigurarea funcționării corecte a site-ului.</li>
                    <li>Statistici anonime de trafic (prin Google Analytics, dacă este activat).</li>
                    <li>Comunicarea cu clienții interesați de mașini.</li>
                </ul>
            </>
        },
        {
            icon: 'bi-cookie', title: '3. Cookie-uri',
            body: <>Acest site poate folosi cookie-uri pentru a îmbunătăți experiența de navigare (ex.: ținerea minte a filtrelor selectate). Puteți dezactiva cookie-urile din setările browserului dumneavoastră.</>
        },
        {
            icon: 'bi-share-fill', title: '4. Partajarea Datelor',
            body: <><strong>Nu vindem</strong> și nu înstrăinăm datele dumneavoastră personale către terți în scopuri de marketing. Datele pot fi transmise autorităților doar dacă există o obligație legală.</>
        },
        {
            icon: 'bi-person-check-fill', title: '5. Drepturile Dumneavoastră',
            body: <>
                Conform GDPR, aveți dreptul la:
                <ul style={listStyle}>
                    <li>Accesul la datele dumneavoastră.</li>
                    <li>Rectificarea sau ștergerea datelor („dreptul de a fi uitat").</li>
                    <li>Restricționarea prelucrării.</li>
                </ul>
                Pentru exercitarea acestor drepturi, vă rugăm să ne contactați.
            </>
        }
    ];

    return (
        <div style={{ background: '#f0f4f9', minHeight: '100vh' }}>

            {/* ══════════════════════════════════════════════════════════════
                SECTION 1 — HERO (dark navy)
            ══════════════════════════════════════════════════════════════ */}
            <div className="position-relative page-hero" style={{ background: trustNavy, paddingTop: isMobile ? '32px' : '120px', paddingBottom: isMobile ? '40px' : '64px' }}>
                <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: heroTexture }}></div>
                <div className="container text-center text-white position-relative">
                    <div style={{
                        display: 'inline-block', background: `${primaryOrange}22`,
                        border: `1px solid ${primaryOrange}55`, color: primaryOrange,
                        fontSize: '0.75rem', fontWeight: '700', textTransform: 'uppercase',
                        letterSpacing: '3px', padding: '5px 16px', borderRadius: '40px', marginBottom: '18px'
                    }}>GDPR</div>
                    <h1 style={{
                        fontWeight: '800', letterSpacing: isMobile ? '1px' : '3px',
                        fontSize: isMobile ? '2rem' : 'clamp(2.2rem, 5vw, 3.5rem)',
                        textTransform: 'uppercase', color: '#ffffff', lineHeight: '1.15', marginBottom: '12px'
                    }}>Confidențialitate</h1>
                    <div style={{ width: '50px', height: '3px', background: primaryOrange, margin: '0 auto 16px', borderRadius: '2px' }}></div>
                    <p style={{ opacity: 0.7, maxWidth: '460px', margin: '0 auto', fontSize: '1rem', lineHeight: '1.7' }}>
                        Confidențialitatea datelor dumneavoastră este importantă pentru noi. Această politică explică ce date colectăm și cum le folosim.
                    </p>
                    <p style={{ opacity: 0.7, fontSize: '0.875rem', margin: '12px 0 0' }}>Conform Regulamentului UE 2016/679 (GDPR)</p>
                </div>
            </div>

            {/* ══════════════════════════════════════════════════════════════
                SECTION 2 — CONȚINUT (light)
            ══════════════════════════════════════════════════════════════ */}
            <div className="ip-section">
                <div className="container">
                    <div className="row g-3">
                        {sections.map((s, i) => (
                            <div className="col-12 col-md-6" key={i}>
                                <div className="ip-card">
                                    <div className="ip-tile ip-tile--sm">
                                        <i className={`bi ${s.icon}`}></i>
                                    </div>
                                    <div>
                                        <h6 className="ip-card-title">{s.title}</h6>
                                        <div className="ip-card-text">{s.body}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Confidentialitate;
